// Module
var code = "<a class=\"vui-href tw-font-semibold tw-underline\" ng-transclude></a>\n";
// Exports
module.exports = code;